// extracted by mini-css-extract-plugin
export default {"root":"OnboardPassword__root--cBQfjh","center":"OnboardPassword__center--vQbJlx"};